<a href="https://www.gob.mx/cms/uploads/attachment/file/25111/NMX-R-025-SCFI-2015_2015_DGN.pdf">
   <app-banner></app-banner>
</a>
<div class="container">
   <div class="row">
      <app-docs class="col-12 mb-5"></app-docs>
      <app-acordition class="col-12 mb-5"></app-acordition>
   </div>
</div>